/**
 * Zones Module
 * Handles planting zone information and functionality
 */

// Zone information database
const zoneInformation = {
    zone1: {
        name: "Zone 1 A/B (Below -50°F)",
        lastFrostDate: "June 15",
        firstFrostDate: "August 15",
        temperatureRange: "Below -50°F",
        vegetables: ["Kale", "Spinach", "Lettuce", "Radish", "Peas"],
        herbs: ["Chives", "Parsley", "Thyme"],
        flowers: ["Pansies", "Snapdragons", "Marigolds"]
    },
    zone2: {
        name: "Zone 2 A/B (-50°F to -40°F)",
        lastFrostDate: "June 1",
        firstFrostDate: "September 1",
        temperatureRange: "-50°F to -40°F",
        vegetables: ["Kale", "Spinach", "Lettuce", "Radish", "Peas", "Potato", "Cabbage"],
        herbs: ["Chives", "Parsley", "Thyme", "Dill"],
        flowers: ["Pansies", "Snapdragons", "Marigolds", "Petunias"]
    },
    zone3: {
        name: "Zone 3 A/B (-40°F to -30°F)",
        lastFrostDate: "May 15",
        firstFrostDate: "September 15",
        temperatureRange: "-40°F to -30°F",
        vegetables: ["Kale", "Spinach", "Lettuce", "Radish", "Peas", "Cabbage", "Potato", "Broccoli", "Carrots"],
        herbs: ["Chives", "Parsley", "Thyme", "Dill", "Oregano"],
        flowers: ["Pansies", "Snapdragons", "Marigolds", "Petunias", "Sunflowers"]
    },
    zone4: {
        name: "Zone 4 A/B (-30°F to -20°F)",
        lastFrostDate: "May 1",
        firstFrostDate: "October 1",
        temperatureRange: "-30°F to -20°F",
        vegetables: ["Kale", "Spinach", "Lettuce", "Radish", "Peas", "Cabbage", "Potato", "Broccoli", "Carrots", "Beets", "Onions"],
        herbs: ["Chives", "Parsley", "Thyme", "Dill", "Oregano", "Rosemary", "Sage"],
        flowers: ["Pansies", "Snapdragons", "Marigolds", "Petunias", "Sunflowers", "Zinnias", "Cosmos"]
    },
    zone5: {
        name: "Zone 5 A/B (-20°F to -10°F)",
        lastFrostDate: "April 15",
        firstFrostDate: "October 15",
        temperatureRange: "-20°F to -10°F",
        vegetables: ["Tomato", "Hot Pepper", "Beans", "Corn", "Cucumber", "Squash", "Pumpkin", "Zucchini", "Broccoli", "Cabbage"],
        herbs: ["Basil", "Chives", "Parsley", "Thyme", "Dill", "Oregano", "Rosemary", "Sage", "Mint"],
        flowers: ["Pansies", "Snapdragons", "Marigolds", "Petunias", "Sunflowers", "Zinnias", "Cosmos", "Dahlias"]
    },
    zone6: {
        name: "Zone 6A/B (-10°F to 0°F)",
        lastFrostDate: "April 1",
        firstFrostDate: "November 1",
        temperatureRange: "-10°F to 0°F",
        vegetables: ["Tomato", "Hot Pepper", "Beans", "Corn", "Cucumber", "Squash", "Eggplant", "Watermelon", "Cantaloupe"],
        herbs: ["Basil", "Chives", "Parsley", "Thyme", "Dill", "Oregano", "Rosemary", "Sage", "Mint", "Cilantro"],
        flowers: ["Roses", "Snapdragons", "Marigolds", "Petunias", "Sunflowers", "Zinnias", "Cosmos", "Dahlias", "Geraniums"]
    },
    zone7: {
        name: "Zone 7 A/B (0°F to 10°F)",
        lastFrostDate: "March 15",
        firstFrostDate: "November 15",
        temperatureRange: "0°F to 10°F",
        vegetables: ["Tomato", "Hot Pepper", "Eggplant", "Okra", "Beans", "Corn", "Cucumber", "Squash", "Watermelon"],
        herbs: ["Basil", "Chives", "Parsley", "Thyme", "Dill", "Oregano", "Rosemary", "Sage", "Mint", "Cilantro", "Lavender"],
        flowers: ["Roses", "Snapdragons", "Marigolds", "Petunias", "Sunflowers", "Zinnias", "Cosmos", "Dahlias", "Geraniums", "Lilies"]
    },
    zone8: {
        name: "Zone 8 A/B (10°F to 20°F)",
        lastFrostDate: "March 1",
        firstFrostDate: "November 30",
        temperatureRange: "10°F to 20°F",
        vegetables: ["Tomato", "Hot Pepper", "Eggplant", "Okra", "Sweet Potatoes", "Watermelon", "Cantaloupe", "Pumpkin"],
        herbs: ["Basil", "Chives", "Parsley", "Thyme", "Dill", "Oregano", "Rosemary", "Sage", "Mint", "Cilantro", "Lavender", "Lemongrass"],
        flowers: ["Roses", "Hibiscus", "Marigolds", "Petunias", "Sunflowers", "Zinnias", "Cosmos", "Dahlias", "Geraniums", "Lilies"]
    },
    zone9: {
        name: "Zone 9 A/B (20°F to 30°F)",
        lastFrostDate: "February 1",
        firstFrostDate: "December 15",
        temperatureRange: "20°F to 30°F",
        vegetables: ["Tomato", "Pepper", "Eggplant", "Okra", "Sweet Potatoes", "Watermelon", "Cantaloupe", "Citrus"],
        herbs: ["Basil", "Chives", "Parsley", "Thyme", "Dill", "Oregano", "Rosemary", "Sage", "Mint", "Cilantro", "Lavender", "Lemongrass", "Turmeric"],
        flowers: ["Roses", "Hibiscus", "Bougainvillea", "Petunias", "Sunflowers", "Zinnias", "Cosmos", "Dahlias", "Geraniums", "Lilies"]
    },
    zone10: {
        name: "Zone 10 A/B (30°F to 40°F)",
        lastFrostDate: "January 15",
        firstFrostDate: "December 31",
        temperatureRange: "30°F to 40°F",
        vegetables: ["Tomato", "Hot Pepper", "Eggplant", "Okra", "Sweet Potatoes", "Tropical Fruits", "Avocado"],
        herbs: ["Basil", "Chives", "Parsley", "Thyme", "Dill", "Oregano", "Rosemary", "Sage", "Mint", "Cilantro", "Lavender", "Lemongrass", "Turmeric", "Ginger"],
        flowers: ["Roses", "Hibiscus", "Bougainvillea", "Orchids", "Sunflowers", "Zinnias", "Bird of Paradise", "Dahlias", "Geraniums", "Lilies"]
    },
    zone11: {
        name: "Zone 11 A/B (40°F to 50°F)",
        lastFrostDate: "N/A",
        firstFrostDate: "N/A",
        temperatureRange: "40°F to 50°F",
        vegetables: ["Tomato", "Hot Pepper", "Eggplant", "Okra", "Sweet Potatoes", "Tropical Fruits", "Pineapple", "Mango"],
        herbs: ["Basil", "Chives", "Parsley", "Thyme", "Oregano", "Rosemary", "Sage", "Mint", "Cilantro", "Lavender", "Lemongrass", "Turmeric", "Ginger", "Galangal"],
        flowers: ["Tropical Hibiscus", "Bougainvillea", "Orchids", "Plumeria", "Bird of Paradise", "Heliconia", "Anthurium", "Jasmine"]
    },
    zone12: {
        name: "Zone 12 A/B (50°F to 60°F)",
        lastFrostDate: "N/A",
        firstFrostDate: "N/A",
        temperatureRange: "50°F to 60°F",
        vegetables: ["Tomato", "Hot Pepper", "Eggplant", "Okra", "Sweet Potatoes", "Tropical Fruits", "Pineapple", "Mango", "Banana", "Papaya"],
        herbs: ["Basil", "Turmeric", "Ginger", "Galangal", "Lemongrass", "Vanilla", "Curry Leaf"],
        flowers: ["Tropical Hibiscus", "Bougainvillea", "Orchids", "Plumeria", "Bird of Paradise", "Heliconia", "Anthurium", "Jasmine", "Ixora"]
    },
    zone13: {
        name: "Zone 13 A/B (60°F to 70°F)",
        lastFrostDate: "N/A",
        firstFrostDate: "N/A",
        temperatureRange: "60°F to 70°F",
        vegetables: ["Tropical Fruits", "Pineapple", "Mango", "Banana", "Papaya", "Coconut", "Guava", "Passion Fruit"],
        herbs: ["Turmeric", "Ginger", "Galangal", "Lemongrass", "Vanilla", "Curry Leaf", "Kaffir Lime"],
        flowers: ["Tropical Hibiscus", "Bougainvillea", "Orchids", "Plumeria", "Bird of Paradise", "Heliconia", "Anthurium", "Jasmine", "Ixora", "Gardenia"]
    }
};

function updateZoneInformation() {
    const zoneSelect = document.getElementById('zone-select');
    const zoneInfo = document.getElementById('zone-info');
    const zoneDisplayContainer = document.getElementById('zone-display-container');
    
    if (!zoneSelect) return;
    
    const selectedZone = zoneSelect.value;
    
    // Add or remove the has-selection class based on whether a zone is selected
    if (selectedZone && zoneInformation[selectedZone]) {
        zoneSelect.classList.add('has-selection');
    } else {
        zoneSelect.classList.remove('has-selection');
    }

    // Keep the selection UI visible (it lives inside this container now)
    if (zoneDisplayContainer) zoneDisplayContainer.style.display = 'block';

    // Zone info table is optional (may not exist if removed from the page)
    if (!zoneInfo) return;

    if (!selectedZone || !zoneInformation[selectedZone]) {
        zoneInfo.innerHTML = '<p>Select a Zone to see recommended plants.</p>';
        return;
    }

    const zone = zoneInformation[selectedZone];

    // Create table format like in the original design
    zoneInfo.innerHTML = `
        <div class="zone-table-container">
            <table class="zone-info-table">
                <thead>
                    <tr>
                        <th>Last Frost Date</th>
                        <th>First Frost Date</th>
                        <th>Temperature Range</th>
                        <th>Vegetables</th>
                        <th>Herbs</th>
                        <th>Flowers</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>${zone.lastFrostDate}</td>
                        <td>${zone.firstFrostDate}</td>
                        <td>${zone.temperatureRange}</td>
                        <td>${zone.vegetables.join(', ')}</td>
                        <td>${zone.herbs.join(', ')}</td>
                        <td>${zone.flowers.join(', ')}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    `;
}

function highlightPlantButtons() {
    const zoneSelect = document.getElementById('zone-select');
    const plantButtons = document.querySelectorAll('.grid-item');
    const clearZoneButton = document.getElementById('clear-zone');
    
    if (!zoneSelect) return;
    
    const selectedZone = zoneSelect.value;
    
    // Remove all existing zone highlights
    plantButtons.forEach(button => {
        button.classList.remove('zone-highlighted');
    });

    // Toggle highlight on clear-zone button
    if (clearZoneButton) {
        if (selectedZone && zoneInformation[selectedZone]) {
            clearZoneButton.classList.add('zone-highlighted');
        } else {
            clearZoneButton.classList.remove('zone-highlighted');
        }
    }

    if (!selectedZone || !zoneInformation[selectedZone]) {
        hideGardenPlannerMessage();
        return;
    }
    
    const zone = zoneInformation[selectedZone];
    const allZonePlants = [...zone.vegetables, ...zone.herbs, ...zone.flowers];
    
    // Highlight buttons for plants that are suitable for the selected zone
    plantButtons.forEach(button => {
        const plantName = button.textContent.trim();
        
        // Check if this plant is in the zone's recommended plants
        const isRecommended = allZonePlants.some(zonePlant => 
            zonePlant.toLowerCase().includes(plantName.toLowerCase()) ||
            plantName.toLowerCase().includes(zonePlant.toLowerCase())
        );
        
        if (isRecommended) {
            button.classList.add('zone-highlighted');
        }
    });
}

// Function to show the garden planner message
function showGardenPlannerMessage() {
    const message = document.getElementById('garden-planner-message');
    if (message) {
        message.classList.remove('hide');
        message.classList.add('show');
        
        // Auto-hide the message after 5 seconds
        setTimeout(() => {
            hideGardenPlannerMessage();
        }, 5000);
    }
}

// Function to hide the garden planner message
function hideGardenPlannerMessage() {
    const message = document.getElementById('garden-planner-message');
    if (message) {
        message.classList.remove('show');
        message.classList.add('hide');
    }
}

// Function to check if user is at the garden planner section
function checkGardenPlannerScroll() {
    const gardenNameElement = document.getElementById('garden-name');
    const message = document.getElementById('garden-planner-message');
    const zoneSelect = document.getElementById('zone-select');
    
    if (!gardenNameElement || !message) return;
    
    // Only show the message when a zone is selected
    if (!zoneSelect?.value) {
        if (message.classList.contains('show')) {
            hideGardenPlannerMessage();
        }
        return;
    }
    
    const rect = gardenNameElement.getBoundingClientRect();
    const isVisible = rect.top <= 100 && rect.bottom >= 100; // Within 100px of top
    
    if (isVisible && !message.classList.contains('show')) {
        showGardenPlannerMessage();
    } else if (!isVisible && message.classList.contains('show')) {
        hideGardenPlannerMessage();
    }
}

export function initializeZones() {
    // Add event listener for the zone select dropdown
    const zoneSelect = document.getElementById('zone-select');
    if (zoneSelect) {
        zoneSelect.addEventListener('change', function() {
            updateZoneInformation();
            highlightPlantButtons(); // Update highlights when zone changes
            showGardenPlannerMessage();
        });
    }
    
    // Add event listener for clear zone button
    const clearZoneButton = document.getElementById('clear-zone');
    if (clearZoneButton) {
        clearZoneButton.addEventListener('click', function() {
            const zoneSelect = document.getElementById('zone-select');
            const zoneInfo = document.getElementById('zone-info');
            const zoneDisplayContainer = document.getElementById('zone-display-container');
            
            if (zoneSelect) {
                zoneSelect.value = '';
                zoneSelect.classList.remove('has-selection'); // Remove the selection styling
            }
            if (zoneInfo) zoneInfo.innerHTML = '<p> Select a Zone to see recommended plants.</p>';
            
            // Keep zone selection UI visible
            if (zoneDisplayContainer) zoneDisplayContainer.style.display = 'block';
            
            // Remove all highlights including from the clear button itself
            const plantButtons = document.querySelectorAll('.grid-item');
            plantButtons.forEach(button => {
                button.classList.remove('zone-highlighted');
            });
            clearZoneButton.classList.remove('zone-highlighted');
            
            // Hide the garden planner message
            hideGardenPlannerMessage();
        });
    }
    
    // Add scroll event listener to check garden planner position
    window.addEventListener('scroll', checkGardenPlannerScroll);

    // Initialize zone UI on load (keeps zone display visible with default text)
    updateZoneInformation();
    highlightPlantButtons();
    
    console.log('✅ Zones functionality initialized');
}

// Export zone information and functions for use by other modules
export { zoneInformation, updateZoneInformation, highlightPlantButtons, showGardenPlannerMessage, hideGardenPlannerMessage, checkGardenPlannerScroll };